/**
 * Thema „Mit einem KI-Assistenten verbinden (MCP)" (PV-037, A3): einfache Anleitung für beide
 * Wege — Claude-Code-Plugin (Befehle wie in tools/claude-plugin/README.md) und eigener Konnektor
 * mit der Adresse dieser Anwendung. Nur bei Flag `mcp_server` sichtbar (Registry).
 */
import { useTranslation } from 'react-i18next';
import type { HilfeThemaProps } from './hilfe-typen.js';

/** Technische Befehle, keine Oberflächentexte — bewusst nicht übersetzt. */
const PLUGIN_BEFEHLE = [
  'claude plugin marketplace add https://mindcode.mindsquare.de/lordieck/projektverwaltung.git',
  'claude plugin install projektverwaltung-mcp@mindsquare-projektverwaltung',
] as const;

export function ThemaMcp({ kompakt }: HilfeThemaProps) {
  const { t } = useTranslation();
  const adresse = `${window.location.origin}/mcp`;
  const code = 'block rounded-md px-3 py-2 text-xs break-all';
  const codeStil = {
    background: 'var(--surface-2)',
    color: 'var(--ink)',
    fontFamily: 'var(--f-mono)',
  };
  return (
    <div
      className={`space-y-3 ${kompakt ? 'text-xs' : 'text-sm'}`}
      style={{ color: 'var(--ink-2)' }}
    >
      <p>{t('hilfe.mcp.einleitung')}</p>
      <div className="space-y-1">
        <h3 className="font-medium" style={{ color: 'var(--ink)' }}>
          {t('hilfe.mcp.adresse')}
        </h3>
        <code className={code} style={codeStil}>
          {adresse}
        </code>
      </div>
      <div className="space-y-1">
        <h3 className="font-medium" style={{ color: 'var(--ink)' }}>
          {t('hilfe.mcp.weg_claude_code_titel')}
        </h3>
        <p>{t('hilfe.mcp.weg_claude_code')}</p>
        <pre className={`${code} whitespace-pre-wrap`} style={codeStil}>
          {PLUGIN_BEFEHLE.join('\n')}
        </pre>
      </div>
      <div className="space-y-1">
        <h3 className="font-medium" style={{ color: 'var(--ink)' }}>
          {t('hilfe.mcp.weg_connector_titel')}
        </h3>
        <p>{t('hilfe.mcp.weg_connector')}</p>
      </div>
      <p>{t('hilfe.mcp.anmeldung')}</p>
      <p>{t('hilfe.mcp.rechte')}</p>
    </div>
  );
}
